
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 48 48","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M43.25 24.34c0 11.618-9.417 21.037-21.035 21.037S1.178 35.958 1.178 24.34c0-11.617 9.419-21.036 21.037-21.036 11.618 0 21.036 9.418 21.036 21.037Zm-6.186 0c0 8.201-6.649 14.85-14.85 14.85a14.78 14.78 0 0 1-8.158-2.44l20.568-20.568a14.78 14.78 0 0 1 2.44 8.159Zm-6.842-12.506a14.78 14.78 0 0 0-8.008-2.343c-8.2 0-14.848 6.649-14.848 14.85 0 2.948.86 5.697 2.342 8.007l20.514-20.514Z","fill":"#D0EFEC"}}),_c('path',{attrs:{"d":"M8.367 31.657A18.061 18.061 0 0 1 36.234 9.324M39.992 14.215a18.06 18.06 0 0 1-28.763 21.167M36.852 9.236 10.614 35.474","stroke":"#234652"}})])
          )
        }
      }
    